var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseLanguagePicker',{attrs:{"value":_vm.$i18n.locale,"include":_vm.supportedLanguages,"uiLocale":_vm.uiLocale,"showClose":false},on:{"input":_vm.onLocaleChanged,"close":function($event){return _vm.$emit('close')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }